<alg-left-header [hideTree]="hideTree()" [treeHidden]="compactHeader()" />
<alg-left-tabbed-content class="alg-flex-1"
  [hideTree]="hideTree()"
  (searchActiveChange)="onSearchActiveChange($event)"
 />
